import { StrandedValueComponent } from "@/features/esoPerson/strandedValue/StrandedValueComponent"

export const StrandedValuePage = () => {
  return <StrandedValueComponent />
}
